"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = anonymous;

var _ikeaComponentSwiper = _interopRequireDefault(require("@ikea-aoa/ikea-component-swiper"));

var _ikeaComponentLoadVpc = _interopRequireDefault(require("@ikea-aoa/ikea-component-load-vpc"));

var _ikeaComponentLanguagePicker = _interopRequireDefault(require("@ikea-aoa/ikea-component-language-picker"));

var _ikeaComponentImage = _interopRequireDefault(require("@ikea-aoa/ikea-component-image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function anonymous(locals, escapeFn, include, rethrow) {
  var _this3 = this;

  escapeFn = escapeFn || function (markup) {
    return markup == undefined ? '' : String(markup).replace(_MATCH_HTML, encode_char);
  };

  var _ENCODE_HTML_RULES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&#34;",
    "'": "&#39;"
  },
      _MATCH_HTML = /[&<>'"]/g;

  function encode_char(c) {
    return _ENCODE_HTML_RULES[c] || c;
  }

  ;
  ;
  var __output = "";

  function __append(s) {
    if (s !== undefined && s !== null) __output += s;
  }

  ;

  if (_ikeaComponentSwiper.default.componentName) {
    this.registerComponentToManager(_ikeaComponentSwiper.default);
  }

  if (_ikeaComponentLoadVpc.default.componentName) {
    this.registerComponentToManager(_ikeaComponentLoadVpc.default);
  }

  if (_ikeaComponentLanguagePicker.default.componentName) {
    this.registerComponentToManager(_ikeaComponentLanguagePicker.default);
  }

  if (_ikeaComponentImage.default.componentName) {
    this.registerComponentToManager(_ikeaComponentImage.default);
  }

  ;

  __append("\n\n");

  if (this.applications.length > 1 && this.props.visible) {
    ;

    __append("\n    <div class=\"SeriesGallery");

    __append(escapeFn(this.applications.length > 4 ? ' SeriesGallery--double' : ''));

    __append(escapeFn(this.applications.length > 2 ? ' SeriesGallery--' + (this.applications.length > 3 ? 'x-small' : 'small') : ''));

    __append("\">\n        <ikea-component name=\"LanguagePicker\"></ikea-component>\n        <div class=\"SeriesGallery__title\">");

    __append(escapeFn(this.translate('SERIES_GALLERY_TITLE')));

    __append("</div>\n\n        ");

    if (this.applications.length > 8) {
      ;

      __append("\n            <div class=\"SeriesGallery__swiper\">\n                <ikea-component name=\"Swiper\" data-observ-page=\"false\">\n                    ");

      (function () {
        var _this = this;

        ;

        var _loop = function _loop(_i, max) {
          ;

          __append("\n    ");

          var application = _this.applications[_i];
          ;

          __append("\n    \n    <div class=\"SeriesGallery__swiper-item\">\n        ");

          (function () {
            ;

            if (this.props.redirect) {
              ;

              __append("\n    <a class=\"SeriesGallery__application\" href=\"");

              __append(escapeFn(application.url));

              __append("\" target=\"_top\" onclick=\"this.handleApplicationClick(event, '");

              __append(escapeFn(application.id));

              __append("');\">\n        <ikea-component name=\"Image\" data-src=\"");

              __append(escapeFn(application.image));

              __append("\" data-ric=\"true\"></ikea-component>\n        <div class=\"SeriesGallery__application-title\">");

              __append(escapeFn(application.title || this.translate(application.translation)));

              __append("</div>\n    </a>\n");
            } else {
              ;

              __append("\n    <div class=\"SeriesGallery__application\" onclick=\"this.handleApplicationClick(event, '");

              __append(escapeFn(application.id));

              __append("');\">\n        <ikea-component name=\"Image\" data-src=\"");

              __append(escapeFn(application.image));

              __append("\" data-ric=\"true\"></ikea-component>\n        <div class=\"SeriesGallery__application-title\">");

              __append(escapeFn(application.title || this.translate(application.translation)));

              __append("</div>\n    </div>\n");
            }

            ;
          }).call(_this);

          __append("\n\n        ");

          if (max > 4 && _i < max - 1) {
            ;

            __append("\n            ");

            _i++;
            application = _this.applications[_i];
            ;

            __append("\n            \n            ");

            (function () {
              ;

              if (this.props.redirect) {
                ;

                __append("\n    <a class=\"SeriesGallery__application\" href=\"");

                __append(escapeFn(application.url));

                __append("\" target=\"_top\" onclick=\"this.handleApplicationClick(event, '");

                __append(escapeFn(application.id));

                __append("');\">\n        <ikea-component name=\"Image\" data-src=\"");

                __append(escapeFn(application.image));

                __append("\" data-ric=\"true\"></ikea-component>\n        <div class=\"SeriesGallery__application-title\">");

                __append(escapeFn(application.title || this.translate(application.translation)));

                __append("</div>\n    </a>\n");
              } else {
                ;

                __append("\n    <div class=\"SeriesGallery__application\" onclick=\"this.handleApplicationClick(event, '");

                __append(escapeFn(application.id));

                __append("');\">\n        <ikea-component name=\"Image\" data-src=\"");

                __append(escapeFn(application.image));

                __append("\" data-ric=\"true\"></ikea-component>\n        <div class=\"SeriesGallery__application-title\">");

                __append(escapeFn(application.title || this.translate(application.translation)));

                __append("</div>\n    </div>\n");
              }

              ;
            }).call(_this);

            __append("\n        ");
          }

          ;

          __append("\n    </div>\n");

          i = _i;
        };

        for (var i = 0, max = this.applications.length; i < max; i++) {
          _loop(i, max);
        }

        ;
      }).call(this);

      __append("\n                </ikea-component>\n            </div>\n        ");
    } else {
      ;

      __append("\n            <div class=\"SeriesGallery__swiper SeriesGallery__swiper--disabled\">\n                <div class=\"SeriesGallery__swiper-content\">\n                    ");

      (function () {
        var _this2 = this;

        ;

        var _loop2 = function _loop2(max, _i3) {
          ;

          __append("\n    ");

          var application = _this2.applications[_i3];
          ;

          __append("\n    \n    <div class=\"SeriesGallery__swiper-item\">\n        ");

          (function () {
            ;

            if (this.props.redirect) {
              ;

              __append("\n    <a class=\"SeriesGallery__application\" href=\"");

              __append(escapeFn(application.url));

              __append("\" target=\"_top\" onclick=\"this.handleApplicationClick(event, '");

              __append(escapeFn(application.id));

              __append("');\">\n        <ikea-component name=\"Image\" data-src=\"");

              __append(escapeFn(application.image));

              __append("\" data-ric=\"true\"></ikea-component>\n        <div class=\"SeriesGallery__application-title\">");

              __append(escapeFn(application.title || this.translate(application.translation)));

              __append("</div>\n    </a>\n");
            } else {
              ;

              __append("\n    <div class=\"SeriesGallery__application\" onclick=\"this.handleApplicationClick(event, '");

              __append(escapeFn(application.id));

              __append("');\">\n        <ikea-component name=\"Image\" data-src=\"");

              __append(escapeFn(application.image));

              __append("\" data-ric=\"true\"></ikea-component>\n        <div class=\"SeriesGallery__application-title\">");

              __append(escapeFn(application.title || this.translate(application.translation)));

              __append("</div>\n    </div>\n");
            }

            ;
          }).call(_this2);

          __append("\n\n        ");

          if (max > 4 && _i3 < max - 1) {
            ;

            __append("\n            ");

            _i3++;
            application = _this2.applications[_i3];
            ;

            __append("\n            \n            ");

            (function () {
              ;

              if (this.props.redirect) {
                ;

                __append("\n    <a class=\"SeriesGallery__application\" href=\"");

                __append(escapeFn(application.url));

                __append("\" target=\"_top\" onclick=\"this.handleApplicationClick(event, '");

                __append(escapeFn(application.id));

                __append("');\">\n        <ikea-component name=\"Image\" data-src=\"");

                __append(escapeFn(application.image));

                __append("\" data-ric=\"true\"></ikea-component>\n        <div class=\"SeriesGallery__application-title\">");

                __append(escapeFn(application.title || this.translate(application.translation)));

                __append("</div>\n    </a>\n");
              } else {
                ;

                __append("\n    <div class=\"SeriesGallery__application\" onclick=\"this.handleApplicationClick(event, '");

                __append(escapeFn(application.id));

                __append("');\">\n        <ikea-component name=\"Image\" data-src=\"");

                __append(escapeFn(application.image));

                __append("\" data-ric=\"true\"></ikea-component>\n        <div class=\"SeriesGallery__application-title\">");

                __append(escapeFn(application.title || this.translate(application.translation)));

                __append("</div>\n    </div>\n");
              }

              ;
            }).call(_this2);

            __append("\n        ");
          }

          ;

          __append("\n    </div>\n");

          _i2 = _i3;
        };

        for (var _i2 = 0, max = this.applications.length; _i2 < max; _i2++) {
          _loop2(max, _i2);
        }

        ;
      }).call(this);

      __append("\n                </div>\n            </div>\n        ");
    }

    ;

    __append("\n        \n        ");

    if (this.props.showVpc) {
      ;

      __append("\n            <div class=\"SeriesGallery__vpc\">\n                <ikea-component name=\"LoadVpc\"\n                                data-events=\"");

      __append(escapeFn(_ikeaComponentLoadVpc.default.events({
        start: function start(data) {
          _this3.trigger('vpcStart', data);
        },
        done: function done(data) {
          _this3.setProps({
            visible: false
          });

          _this3.render();

          _this3.trigger('vpcDone', data);
        },
        error: this.trigger.bind(this, 'vpcError')
      })));

      __append("\"\n                                data-application-names=");

      __append(escapeFn(this.props.vpcApplicationNames ? this.props.vpcApplicationNames : ''));

      __append("\n                ></ikea-component>\n            </div>\n        ");
    }

    ;

    __append("\n    </div>\n");
  }

  return __output;
}